import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useHousehold } from './household'

/**
 * Abonnement SSE au foyer courant : à chaque signal `change`, invalide les requêtes inventaire / journal.
 * Le détail des changements reste sur `GET …/changes` (curseur de sync).
 */
export function useHouseholdRealtime() {
  const { current } = useHousehold()
  const qc = useQueryClient()
  const hid = current?.id

  useEffect(() => {
    if (!hid) return
    const es = new EventSource(`/api/v1/households/${encodeURIComponent(hid)}/events`, {
      withCredentials: true,
    })
    const onChange = () => {
      void qc.invalidateQueries({ queryKey: ['contents', hid] })
      void qc.invalidateQueries({ queryKey: ['items', hid] })
      void qc.invalidateQueries({ queryKey: ['activity', hid] })
      void qc.invalidateQueries({ queryKey: ['item'] })
      void qc.invalidateQueries({ queryKey: ['notifications'] })
    }
    es.addEventListener('change', onChange)
    return () => {
      es.removeEventListener('change', onChange)
      es.close()
    }
  }, [hid, qc])
}
